module.exports = __webpack_public_path__ + "static/helm-DND3_FnP-57b560fb2972914e6f3f7a0a210548be.webp";